/**
 * Skill / aura icons (generated with OpenAI image generation via the Codex CLI; see assets/CREDITS.md).
 * Files live in public/assets/icons/<file>.png (128 px) and <file>_64.png (64 px).
 * GENERATED by the icon pipeline; regenerate rather than hand-editing the tables.
 */
import { BASE_VISUAL_ALIAS } from '@keystone/content'; // +classes

/** Ability or aura id -> icon file base name (no extension). Aura ids that share an ability icon are aliased. */
export const ICON_MANIFEST: Readonly<Record<string, string>> = {
  'blademaster.battlelord': 'blademaster_battlelord',
  'blademaster.bladestorm': 'blademaster_bladestorm',
  'blademaster.charge': 'blademaster_charge',
  'common.dodge': 'common_dodge',
  'blademaster.cleave': 'blademaster_cleave',
  'blademaster.cleave_buff': 'blademaster_cleave',
  'blademaster.colossus_smash': 'blademaster_colossus_smash',
  'blademaster.die_by_the_sword': 'blademaster_die_by_the_sword',
  'blademaster.execute': 'blademaster_execute',
  'blademaster.executioners_precision': 'blademaster_executioners_precision',
  'blademaster.mortal_strike': 'blademaster_mortal_strike',
  'blademaster.overpower': 'blademaster_overpower',
  'blademaster.overpower_proc': 'blademaster_tactician',
  'blademaster.pummel': 'blademaster_pummel',
  'blademaster.ravagers_finale': 'blademaster_ravagers_finale',
  'blademaster.ravagers_finale_ready': 'blademaster_ravagers_finale',
  'blademaster.rend': 'blademaster_rend',
  'blademaster.shockwave': 'blademaster_shockwave',
  'blademaster.shockwave_ready': 'blademaster_shockwave',
  'blademaster.slam': 'blademaster_slam',
  'blademaster.sudden_death': 'blademaster_sudden_death',
  'blademaster.t3.executioner': 'blademaster_t3_executioner',
  'blademaster.t3.ravagers_storm': 'blademaster_t3_ravagers_storm',
  'blademaster.t3.unbreakable': 'blademaster_t3_unbreakable',
  'blademaster.tactician': 'blademaster_tactician',
  'blademaster.wounds': 'blademaster_wounds',
  'chieftain.bone_cyclone': 'chieftain_bone_cyclone',
  'chieftain.boneslice': 'chieftain_boneslice',
  'chieftain.boneslicer': 'chieftain_boneslicer',
  'chieftain.chop_down': 'chieftain_chop_down',
  'chieftain.fang_ritual': 'chieftain_fang_ritual',
  'chieftain.ritual_of_the_fang': 'chieftain_ritual_of_the_fang',
  'coil.burrowing_charge': 'coil_burrowing_charge',
  'coil.tail_scythe': 'coil_tail_scythe',
  'coil.toxic_atrophy': 'coil_toxic_atrophy',
  'coil.venom_jet': 'coil_venom_jet',
  'coil.writhe_assimilate': 'coil_writhe_assimilate',
  'coil.writhe_toxic_atrophy': 'coil_toxic_atrophy',
  // Encounter rework enemy casts and debuffs (docs/design/encounters.md); aliases share an icon.
  'npc.reaver.blood_frenzy': 'npc_reaver_blood_frenzy',
  'npc.reaver.blood_frenzy_7': 'npc_reaver_blood_frenzy',
  'npc.reaver.hemorrhage': 'npc_reaver_hemorrhage',
  'npc.adept.ascension_rite': 'npc_adept_ascension_rite',
  'npc.adept.ascension_rite_7': 'npc_adept_ascension_rite',
  'npc.adept.ascended': 'npc_adept_ascension_rite',
  'npc.adept.envenom': 'npc_adept_envenom',
  'npc.serpent.piercing_hiss': 'npc_serpent_piercing_hiss',
  'npc.serpent.silenced': 'npc_serpent_piercing_hiss',
  'npc.constrictor.coagulating_venom': 'npc_constrictor_coagulating_venom',
  'npc.constrictor.constricted': 'npc_constrictor_constricted',
  'npc.basilisk.petrified_10': 'npc_basilisk_petrified',
  'npc.priestess.scale_ward_haste': 'npc_priestess_scale_ward',
  'npc.venomspawn.septic': 'ravager_bile_burn',
  'ravager.feeding_frenzy': 'ravager_feeding_frenzy',
  'ravager.gorged': 'ravager_feeding_frenzy',
  'ravager.gorged_hide': 'ravager_gorged_hide',
  'ravager.hunting_pounce': 'ravager_hunting_pounce',
  'ravager.septic_bite': 'ravager_septic_bite',
  'ravager.septic_bite_passive': 'ravager_septic_bite',
  'ravager.bile_burn': 'ravager_bile_burn',
  'ravager.barbed': 'ravager_triple_shot',
  'ravager.whelp_fixate': 'ravager_whelp_fixate',
  'ravager.whelp_ravenous': 'npc_reaver_blood_frenzy',
  'coil.synchronized_venom': 'coil_synchronized_venom',
  'coil.synchronized_venom_7': 'coil_synchronized_venom',
  'coil.toxic_atrophy_p2': 'coil_toxic_atrophy',
  'coil.death_rattle': 'coil_death_rattle',
  'coil.sluggish_venom': 'coil_sluggish_venom',
  'coil.venom_torrent': 'coil_venom_torrent',
  'coil.coiling_vortex': 'coil_coiling_vortex',
  'coil.writhe_recoil': 'coil_writhe_recoil',
  'coil.writhe_fixate': 'ravager_whelp_fixate',
  'coil.burrowed': 'coil_burrowing_charge',
  'coil.venom_jet_poison': 'coil_venom_jet',
  'chieftain.ritual_of_the_fang_p2': 'chieftain_ritual_of_the_fang',
  'chieftain.ritual_venom': 'chieftain_ritual_venom',
  'chieftain.fang_empowerment': 'chieftain_fang_ritual',
  'chieftain.chop_down_combo': 'chieftain_chop_down',
  'chieftain.axegrinder': 'chieftain_axegrinder',
  'chieftain.bloodroar': 'chieftain_bloodroar',
  'chieftain.bloodroar_bleed': 'chieftain_bloodroar',
  'chieftain.bloodrage': 'chieftain_bloodrage',
  'chieftain.bloodrage_10': 'chieftain_bloodrage',
  'chieftain.blood_sacrifice': 'chieftain_blood_sacrifice',
  'chieftain.blood_offering': 'chieftain_blood_sacrifice',
  // Altar Forge resources and reagents (crafting.md §1). Keys are `forge.<resource id>`; wallet-field aliases included.
  'forge.blessed': 'forge_blessed',
  'forge.eye': 'forge_eye',
  'forge.eye_fragment': 'forge_eye_fragment',
  'forge.eyeFragments': 'forge_eye_fragment',
  'forge.fangsteel': 'forge_fangsteel',
  'forge.moltskin': 'forge_moltskin',
  'forge.scale.ashen': 'forge_scale_ashen',
  'forge.scale.eternal': 'forge_scale_eternal',
  'forge.scale.gilded': 'forge_scale_gilded',
  'forge.scale.jade': 'forge_scale_jade',
  'forge.sigil': 'forge_sigil',
  'forge.sigils': 'forge_sigil',
  'forge.vault_token': 'forge_vault_token',
  'forge.venom': 'forge_venom',
  'lightbinder.avenging_light': 'lightbinder_avenging_light',
  'lightbinder.blessing_of_freedom': 'lightbinder_blessing_of_freedom',
  'lightbinder.cleanse': 'lightbinder_cleanse',
  'lightbinder.dawnbringer': 'lightbinder_dawnbringer',
  'lightbinder.dawnlight': 'lightbinder_dawnlight',
  'lightbinder.dawnsong': 'lightbinder_dawnsong',
  'lightbinder.divine_purpose': 'lightbinder_divine_purpose',
  'lightbinder.divine_shield': 'lightbinder_divine_shield',
  'lightbinder.flash_heal': 'lightbinder_flash_heal',
  'lightbinder.glorious_dawn': 'lightbinder_glorious_dawn',
  'lightbinder.guardians_aegis': 'lightbinder_guardians_aegis',
  'lightbinder.hammer_of_dawn': 'lightbinder_hammer_of_dawn',
  'lightbinder.hammer_of_dawn_ready': 'lightbinder_hammer_of_dawn',
  'lightbinder.holy_shock': 'lightbinder_holy_shock',
  'lightbinder.infusion_of_light': 'lightbinder_infusion_of_light',
  'lightbinder.judgment': 'lightbinder_judgment',
  'lightbinder.radiant_wave': 'lightbinder_radiant_wave',
  'lightbinder.radiant_wave_hot': 'lightbinder_radiant_wave',
  'lightbinder.sunfall': 'lightbinder_sunfall',
  'lightbinder.sunfall_ready': 'lightbinder_sunfall',
  'lightbinder.sunlit_shock': 'lightbinder_sunlit_shock',
  'lightbinder.sunlit_shock_ready': 'lightbinder_sunlit_shock',
  'lightbinder.t3.crusader': 'lightbinder_t3_crusader',
  'lightbinder.t3.last_rites': 'lightbinder_t3_last_rites',
  'lightbinder.t3.sunburst': 'lightbinder_t3_sunburst',
  'lightbinder.word_of_light': 'lightbinder_word_of_light',
  'npc.adept.venom_bolt': 'npc_adept_venom_bolt',
  'npc.basilisk.petrified': 'npc_basilisk_petrified',
  'npc.basilisk.petrifying_glare': 'npc_basilisk_petrifying_glare',
  'npc.basilisk.tail_lash': 'npc_basilisk_tail_lash',
  'npc.basilisk.venom_rain': 'npc_basilisk_venom_rain',
  'npc.constrictor.crushing_coils': 'npc_constrictor_crushing_coils',
  'npc.constrictor.venom_nova': 'npc_constrictor_venom_nova',
  'npc.mesmer.hypnosis': 'npc_mesmer_hypnosis',
  'npc.mesmer.hypnotic_gaze': 'npc_mesmer_hypnotic_gaze',
  'npc.priestess.scale_ward': 'npc_priestess_scale_ward',
  'npc.priestess.serpents_mending': 'npc_priestess_serpents_mending',
  'npc.reaver.lacerate': 'npc_reaver_lacerate',
  'npc.reaver.rend_flesh': 'npc_reaver_rend_flesh',
  'npc.serpent.acid_burn': 'npc_serpent_acid_burn',
  'npc.serpent.acid_spew': 'npc_serpent_acid_spew',
  'ravager.ravenous_stomp': 'ravager_ravenous_stomp',
  'ravager.regurgitate': 'ravager_regurgitate',
  'ravager.rending_maw': 'ravager_rending_maw',
  'ravager.triple_shot': 'ravager_triple_shot',
  // Tier sets (crafting.md §5): the set id is the set emblem; `<set id>.<slot>` is each piece.
  'set.blademaster.fangreaver': 'set_blademaster_fangreaver',
  'set.blademaster.fangreaver.boots': 'set_blademaster_fangreaver_boots',
  'set.blademaster.fangreaver.chest': 'set_blademaster_fangreaver_chest',
  'set.blademaster.fangreaver.gloves': 'set_blademaster_fangreaver_gloves',
  'set.blademaster.fangreaver.helm': 'set_blademaster_fangreaver_helm',
  'set.blademaster.fangreaver.legs': 'set_blademaster_fangreaver_legs',
  'set.lightbinder.dawnserpent': 'set_lightbinder_dawnserpent',
  'set.lightbinder.dawnserpent.boots': 'set_lightbinder_dawnserpent_boots',
  'set.lightbinder.dawnserpent.chest': 'set_lightbinder_dawnserpent_chest',
  'set.lightbinder.dawnserpent.gloves': 'set_lightbinder_dawnserpent_gloves',
  'set.lightbinder.dawnserpent.helm': 'set_lightbinder_dawnserpent_helm',
  'set.lightbinder.dawnserpent.legs': 'set_lightbinder_dawnserpent_legs',
  'set.stormcaller.stormscale': 'set_stormcaller_stormscale',
  'set.stormcaller.stormscale.boots': 'set_stormcaller_stormscale_boots',
  'set.stormcaller.stormscale.chest': 'set_stormcaller_stormscale_chest',
  'set.stormcaller.stormscale.gloves': 'set_stormcaller_stormscale_gloves',
  'set.stormcaller.stormscale.helm': 'set_stormcaller_stormscale_helm',
  'set.stormcaller.stormscale.legs': 'set_stormcaller_stormscale_legs',
  'set.warden.coilguard': 'set_warden_coilguard',
  'set.warden.coilguard.boots': 'set_warden_coilguard_boots',
  'set.warden.coilguard.chest': 'set_warden_coilguard_chest',
  'set.warden.coilguard.gloves': 'set_warden_coilguard_gloves',
  'set.warden.coilguard.helm': 'set_warden_coilguard_helm',
  'set.warden.coilguard.legs': 'set_warden_coilguard_legs',
  'stormcaller.arc_torrent': 'stormcaller_arc_torrent',
  'stormcaller.astral_shift': 'stormcaller_astral_shift',
  'stormcaller.chain_lightning': 'stormcaller_chain_lightning',
  'stormcaller.earth_shock': 'stormcaller_earth_shock',
  'stormcaller.earthquake': 'stormcaller_earthquake',
  'stormcaller.flame_shock': 'stormcaller_flame_shock',
  'stormcaller.gathering_storm': 'stormcaller_gathering_storm',
  'stormcaller.lava_beam': 'stormcaller_lava_beam',
  'stormcaller.lava_beam_ready': 'stormcaller_lava_beam',
  'stormcaller.lava_burst': 'stormcaller_lava_burst',
  'stormcaller.lava_surge': 'stormcaller_lava_surge',
  'stormcaller.lightning_bolt': 'stormcaller_lightning_bolt',
  'stormcaller.master_of_elements': 'stormcaller_master_of_elements',
  'stormcaller.static_charge': 'stormcaller_static_charge',
  'stormcaller.stormkeeper': 'stormcaller_stormkeeper',
  'stormcaller.surge_of_power': 'stormcaller_surge_of_power',
  'stormcaller.t3.master_of_flame': 'stormcaller_t3_master_of_flame',
  'stormcaller.t3.storm_unleashed': 'stormcaller_t3_storm_unleashed',
  'stormcaller.t3.stormwalker': 'stormcaller_t3_stormwalker',
  'stormcaller.tempest': 'stormcaller_tempest',
  'stormcaller.tempest_ready': 'stormcaller_tempest',
  'stormcaller.thundercrash': 'stormcaller_thundercrash',
  'stormcaller.thundercrash_ready': 'stormcaller_thundercrash',
  'stormcaller.wind_shear': 'stormcaller_wind_shear',
  'warden.aegis_rebound': 'warden_aegis_rebound',
  'warden.aegis_recall': 'warden_aegis_recall',
  'warden.aegis_recall_ready': 'warden_aegis_recall',
  'warden.aegis_throw': 'warden_aegis_throw',
  'warden.bastion': 'warden_bastion',
  'warden.bulwark_strike': 'warden_bulwark_strike',
  'warden.cleave_strike': 'warden_cleave_strike',
  'warden.consecrated_ground': 'warden_consecrated_ground',
  'warden.consecrated_ground_dr': 'warden_consecrated_ground',
  'warden.consecrated_ground_ward': 'warden_consecrated_ground',
  'warden.grip': 'warden_grip',
  'warden.last_stand': 'warden_last_stand',
  'warden.opening': 'warden_opening',
  'warden.riposte': 'warden_riposte',
  'warden.shield_bash': 'warden_shield_bash',
  'warden.shield_momentum': 'warden_shield_momentum',
  'warden.shield_slam': 'warden_shield_slam',
  'warden.shield_wall_bash': 'warden_shield_wall_bash',
  'warden.t3.avenger': 'warden_t3_avenger',
  'warden.t3.last_stand_heal': 'warden_t3_last_stand_heal',
  'warden.t3.lockdown': 'warden_t3_lockdown',
  'warden.taunt': 'warden_taunt',
  'warden.unyielding_bulwark': 'warden_unyielding_bulwark',
  'warden.unyielding_bulwark_ready': 'warden_unyielding_bulwark',
  // +mage-specs: hand-tinted variants of the lightning / shield icons above (ffmpeg grayscale + tint;
  // frost for the Rimecaller, ember for two Cinderborn buttons). Not from the pipeline.
  'magespec.rime_tithe': 'spec_rime_tithe',
  'magespec.hoarlance': 'spec_hoarlance',
  'magespec.rime_ring': 'spec_rime_ring',
  'magespec.frostfold': 'spec_frostfold',
  'magespec.whiteout': 'spec_whiteout',
  'magespec.frost_mantle': 'spec_frost_mantle',
  'magespec.wandering_glacier': 'spec_wandering_glacier',
  'magespec.deep_winter': 'spec_deep_winter',
  'magespec.frozen': 'spec_frozen',
  'magespec.hoarbite': 'spec_hoarbite',
  'magespec.phoenix_dive': 'spec_phoenix_dive',
  // +acolyte-specs: grayscale + tint variants (ffmpeg; aco/tint.sh): violet for the Heretic, blood red for the Hemomancer.
  'acospec.hexbolt': 'spec_hexbolt',
  'acospec.rotcurse': 'spec_rotcurse',
  'acospec.unholy_tithe': 'spec_unholy_tithe',
  'acospec.wraith_ward': 'spec_wraith_ward',
  'acospec.blight_field': 'spec_blight_field',
  'acospec.hollow_covenant': 'spec_hollow_covenant',
  'acospec.scab': 'spec_scab',
  'acospec.coagulate': 'spec_coagulate',
  'acospec.vein_pact': 'spec_vein_pact',
  'magespec.ashrise_pact': 'spec_ashrise_pact',
  // +ranger-specs: painted with the icon pipeline (scratchpad gen.sh, Codex image gen on the Lava Burst reference).
  'rangerspec.quickdraw': 'spec_ranger_quickdraw',
  'rangerspec.hammer_spray': 'spec_ranger_hammer_spray',
  'rangerspec.snap_shut': 'spec_ranger_snap_shut',
  'rangerspec.high_noon': 'spec_ranger_high_noon',
  'rangerspec.flashbang': 'spec_ranger_flashbang',
  'rangerspec.budding': 'spec_ranger_budding',
  'rangerspec.burstbloom': 'spec_ranger_burstbloom',
  'rangerspec.lifevine': 'spec_ranger_lifevine',
  'rangerspec.overgrowth_surge': 'spec_ranger_overgrowth_surge',
  'rangerspec.worldroot': 'spec_ranger_worldroot',
  'rangerspec.mark_prey': 'spec_ranger_mark_prey',
  'rangerspec.pack_fury': 'spec_ranger_pack_fury',
  'rangerspec.spirit_merge': 'spec_ranger_spirit_merge',
  'rangerspec.stand_guard': 'spec_ranger_stand_guard',
  'rangerspec.fanged_maul': 'spec_ranger_fanged_maul',
  'rangerspec.trail_stride': 'spec_ranger_trail_stride',
  'rangerspec.wildstride': 'spec_ranger_wildstride',
  'rangerspec.thornpin': 'spec_ranger_thornpin',
  'rangerspec.spirit_snare': 'spec_ranger_spirit_snare',
  'rangerspec.bound_leap': 'spec_ranger_bound_leap',
  'rangerspec.spirit_herd': 'spec_ranger_spirit_herd',
  'rangerspec.howl_shot': 'spec_ranger_howl_shot',
  'rangerspec.snarlroot': 'spec_ranger_snarlroot',
};

/**
 * Talent node id -> icon key (an ability id in ICON_MANIFEST). Nodes reuse the icon of the ability they
 * modify; capstones with a unique icon map to themselves.
 */
export const TALENT_ICON: Readonly<Record<string, string>> = {
  'blademaster.t1.bloodcraze': 'blademaster.die_by_the_sword',
  'blademaster.t1.disrupting_pummel': 'blademaster.pummel',
  'blademaster.t1.execute_range': 'blademaster.execute',
  'blademaster.t1.martial_prowess': 'blademaster.overpower',
  'blademaster.t1.rend': 'blademaster.rend',
  'blademaster.t1.shockwave': 'blademaster.shockwave',
  'blademaster.t1.sweeping_strikes': 'blademaster.cleave',
  'blademaster.t1.tactical_reserve': 'blademaster.tactician',
  'blademaster.t1.warbringer': 'blademaster.charge',
  'blademaster.t2.battlelord': 'blademaster.battlelord',
  'blademaster.t2.fervor_of_battle': 'blademaster.mortal_strike',
  'blademaster.t2.impending_victory': 'blademaster.execute',
  'blademaster.t2.overwhelm': 'blademaster.overpower',
  'blademaster.t2.second_wind': 'blademaster.die_by_the_sword',
  'blademaster.t2.test_of_might': 'blademaster.colossus_smash',
  'blademaster.t2.unhinged': 'blademaster.bladestorm',
  'blademaster.t3.collateral_damage': 'blademaster.cleave',
  'blademaster.t3.executioner': 'blademaster.t3.executioner',
  'blademaster.t3.executioners_precision': 'blademaster.executioners_precision',
  'blademaster.t3.massacre': 'blademaster.execute',
  'blademaster.t3.ravagers_reach': 'blademaster.t3.ravagers_storm',
  'blademaster.t3.ravagers_storm': 'blademaster.t3.ravagers_storm',
  'blademaster.t3.unbreakable': 'blademaster.t3.unbreakable',
  'blademaster.t3.warbreaker': 'blademaster.colossus_smash',
  'lightbinder.t1.flash_hot': 'lightbinder.flash_heal',
  'lightbinder.t1.judgment_of_light': 'lightbinder.judgment',
  'lightbinder.t1.mobile_flash': 'lightbinder.flash_heal',
  'lightbinder.t1.purifying_touch': 'lightbinder.cleanse',
  'lightbinder.t1.reverberation': 'lightbinder.glorious_dawn',
  'lightbinder.t1.shock_charges': 'lightbinder.holy_shock',
  'lightbinder.t1.steadfast_aegis': 'lightbinder.guardians_aegis',
  'lightbinder.t1.swift_verdict': 'lightbinder.judgment',
  'lightbinder.t2.aegis_of_light': 'lightbinder.guardians_aegis',
  'lightbinder.t2.divine_purpose': 'lightbinder.divine_purpose',
  'lightbinder.t2.divine_revelation': 'lightbinder.divine_purpose',
  'lightbinder.t2.inflorescence': 'lightbinder.infusion_of_light',
  'lightbinder.t2.infusion_of_light': 'lightbinder.infusion_of_light',
  'lightbinder.t2.tidal_radiance': 'lightbinder.radiant_wave',
  'lightbinder.t2.unshackled': 'lightbinder.blessing_of_freedom',
  'lightbinder.t2.word_of_radiance': 'lightbinder.word_of_light',
  'lightbinder.t3.crusader': 'lightbinder.t3.crusader',
  'lightbinder.t3.glimmer': 'lightbinder.holy_shock',
  'lightbinder.t3.last_rites': 'lightbinder.t3.last_rites',
  'lightbinder.t3.purifying_light': 'lightbinder.radiant_wave',
  'lightbinder.t3.purifying_wave': 'lightbinder.radiant_wave',
  'lightbinder.t3.rising_sunlight': 'lightbinder.sunlit_shock',
  'lightbinder.t3.sunburst': 'lightbinder.t3.sunburst',
  'stormcaller.t1.aftershock': 'stormcaller.earth_shock',
  'stormcaller.t1.forked': 'stormcaller.chain_lightning',
  'stormcaller.t1.lava_flow': 'stormcaller.lava_surge',
  'stormcaller.t1.lava_surge': 'stormcaller.lava_surge',
  'stormcaller.t1.spirit_walk': 'stormcaller.astral_shift',
  'stormcaller.t1.spreading_flame': 'stormcaller.flame_shock',
  'stormcaller.t1.thundering_shear': 'stormcaller.wind_shear',
  'stormcaller.t1.walking_bolt': 'stormcaller.lightning_bolt',
  'stormcaller.t2.ancestral_guidance': 'stormcaller.astral_shift',
  'stormcaller.t2.capacitor': 'stormcaller.wind_shear',
  'stormcaller.t2.earthshaker': 'stormcaller.earthquake',
  'stormcaller.t2.static_discharge': 'stormcaller.static_charge',
  'stormcaller.t2.surge_of_power': 'stormcaller.surge_of_power',
  'stormcaller.t2.volcanic_stride': 'stormcaller.lava_burst',
  'stormcaller.t3.ascendance': 'stormcaller.lava_beam',
  'stormcaller.t3.echo_of_elements': 'stormcaller.lava_burst',
  'stormcaller.t3.master_of_flame': 'stormcaller.t3.master_of_flame',
  'stormcaller.t3.searing_flames': 'stormcaller.flame_shock',
  'stormcaller.t3.storm_unleashed': 'stormcaller.t3.storm_unleashed',
  'stormcaller.t3.stormwalker': 'stormcaller.t3.stormwalker',
  'stormcaller.t3.thundercrash': 'stormcaller.thundercrash',
  'warden.t1.bash_charges': 'warden.shield_wall_bash',
  'warden.t1.challenging_roar': 'warden.taunt',
  'warden.t1.resounding_slam': 'warden.shield_slam',
  'warden.t1.ricochet': 'warden.aegis_throw',
  'warden.t1.slam_interrupt': 'warden.shield_slam',
  'warden.t1.sweeping_guard': 'warden.cleave_strike',
  'warden.t1.tempered_resolve': 'warden.bulwark_strike',
  'warden.t1.wide_ground': 'warden.consecrated_ground',
  'warden.t2.bulwark_ward': 'warden.bulwark_strike',
  'warden.t2.counterweight': 'warden.bastion',
  'warden.t2.iron_chain': 'warden.grip',
  'warden.t2.retaliation': 'warden.shield_wall_bash',
  'warden.t2.sanctified_ground': 'warden.consecrated_ground',
  'warden.t2.shield_mastery': 'warden.shield_momentum',
  'warden.t2.warding_bash': 'warden.shield_bash',
  'warden.t3.avenger': 'warden.t3.avenger',
  'warden.t3.counterweight': 'warden.bastion',
  'warden.t3.last_stand_heal': 'warden.t3.last_stand_heal',
  'warden.t3.lockdown': 'warden.t3.lockdown',
  'warden.t3.second_wind': 'warden.last_stand',
  'warden.t3.twin_slams': 'warden.shield_slam',
};

/**
 * +classes / +basekits: base-kit abilities and auras without painted icons borrow the closest
 * existing ones (placeholders; `ui.animAs` covers the rest through BASE_VISUAL_ALIAS).
 */
const BASE_ICON: Readonly<Record<string, string>> = {
  // Ranger
  'ranger.true_draw': 'stormcaller.wind_shear',
  'ranger.longshot': 'lightbinder.judgment',
  'ranger.arrowfall': 'blademaster.bladestorm',
  'ranger.snare_coil': 'lightbinder.blessing_of_freedom',
  'ranger.snare_coil_root': 'lightbinder.blessing_of_freedom',
  'ranger.backflip': 'common.dodge',
  'ranger.swiftfoot': 'stormcaller.t3.stormwalker',
  'ranger.swiftfoot_buff': 'stormcaller.t3.stormwalker',
  'ranger.pin_shot': 'blademaster.executioners_precision',
  // Warrior
  'warrior.headlong': 'blademaster.charge',
  'warrior.headlong_root': 'blademaster.charge',
  'warrior.rive': 'blademaster.rend',
  'warrior.rive_bleed': 'blademaster.rend',
  'warrior.bloodprize': 'blademaster.sudden_death',
  'warrior.fresh_kill': 'blademaster.sudden_death',
  'warrior.iron_breath_buff': 'warden.last_stand',
  // Rogue
  'rogue.lurk': 'stormcaller.astral_shift',
  'rogue.lurk_buff': 'stormcaller.astral_shift',
  'rogue.dirty_opener': 'blademaster.shockwave',
  'rogue.reeling_stun': 'blademaster.shockwave',
  'rogue.throatjab': 'blademaster.pummel',
  'rogue.ashveil_buff': 'blademaster.die_by_the_sword',
  // Mage
  'mage.hoarbind': 'warden.t3.lockdown',
  'mage.hoarbound_root': 'warden.t3.lockdown',
  'mage.wandering_star': 'stormcaller.tempest',
  'mage.glyph_shield_absorb': 'stormcaller.astral_shift',
  // Acolyte
  'acolyte.dawnbrand': 'lightbinder.dawnlight',
  'acolyte.dawnbrand_dot': 'lightbinder.dawnlight',
  'acolyte.hearthward': 'lightbinder.glorious_dawn',
  'acolyte.hearthward_buff': 'lightbinder.glorious_dawn',
  'acolyte.dazzle': 'lightbinder.t3.sunburst',
  'acolyte.dazzled_stun': 'lightbinder.t3.sunburst',
  'acolyte.aegis_absorb': 'lightbinder.guardians_aegis',
};

/**
 * +specs: spec auras (and abilities whose ui.animAs icon reads wrong) borrow the closest painted
 * icon. Abilities fall back through ui.animAs (BASE_VISUAL_ALIAS); class agents add their auras here.
 */
const SPEC_ICON: Readonly<Record<string, string>> = {
  // Ironclad
  'ironclad.plating': 'warden.bastion',
  'ironclad.unstoppable': 'blademaster.t3.unbreakable',
  'ironclad.braced': 'warden.shield_wall_bash',
  'ironclad.anchored': 'warden.grip',
  'ironclad.shrapnel_bleed': 'blademaster.wounds',
  'ironclad.plate_aegis_absorb': 'warden.last_stand',
  'ironclad.plate_aegis_dr': 'warden.last_stand',
  'ironclad.iron_maiden_buff': 'warden.riposte',
  // Ravager
  'ravager.overdrive': 'npc.reaver.blood_frenzy',
  'ravager.carnage': 'blademaster.battlelord',
  'ravager.cyclone_edge': 'blademaster.cleave_buff',
  'ravager.unchained_buff': 'chieftain.bloodrage',
  'ravager.breakneck_root': 'blademaster.charge',
  'ravager.wrathblood_dr': 'blademaster.die_by_the_sword',
  // Bloodreaver
  'bloodreaver.red_thirst': 'chieftain.bloodrage',
  'bloodreaver.weeping_wound': 'chieftain.bloodroar_bleed',
  'bloodreaver.open_vein': 'npc.reaver.hemorrhage',
  'bloodreaver.crimson_trance_buff': 'lightbinder.avenging_light',
  'bloodreaver.sanguine_vigor_dr': 'blademaster.die_by_the_sword',
  'bloodreaver.gorecharge_root': 'blademaster.charge',
  // +mage-specs: Stormcaller / Rimecaller / Cinderborn (abilities and auras).
  'stormcaller.spark': 'stormcaller.lightning_bolt',
  'stormcaller.skybreak': 'stormcaller.thundercrash',
  'stormcaller.static_cage': 'stormcaller.static_charge',
  'stormcaller.static_step': 'stormcaller.wind_shear',
  'stormcaller.chain_storm': 'stormcaller.chain_lightning',
  'stormcaller.arc_ward': 'stormcaller.astral_shift',
  'stormcaller.wandering_tempest': 'stormcaller.tempest',
  'stormcaller.stormheart': 'stormcaller.stormkeeper',
  'stormcaller.overvolt': 'stormcaller.t3.storm_unleashed',
  'stormcaller.static_rush': 'stormcaller.arc_torrent',
  'stormcaller.stormheart_buff': 'stormcaller.stormkeeper',
  'stormcaller.arc_ward_absorb': 'stormcaller.astral_shift',
  'stormcaller.caged': 'stormcaller.static_charge',
  'stormcaller.stormcell': 'stormcaller.gathering_storm',
  'rimecaller.rime_tithe': 'magespec.rime_tithe',
  'rimecaller.hoarlance': 'magespec.hoarlance',
  'rimecaller.rime_ring': 'magespec.rime_ring',
  'rimecaller.frostfold': 'magespec.frostfold',
  'rimecaller.whiteout': 'magespec.whiteout',
  'rimecaller.frost_mantle': 'magespec.frost_mantle',
  'rimecaller.wandering_glacier': 'magespec.wandering_glacier',
  'rimecaller.deep_winter': 'magespec.deep_winter',
  'rimecaller.frozen': 'magespec.frozen',
  'rimecaller.iced_in': 'magespec.rime_ring',
  'rimecaller.chill': 'magespec.rime_tithe',
  'rimecaller.hoarbite': 'magespec.hoarbite',
  'rimecaller.brimming': 'magespec.hoarlance',
  'rimecaller.frost_mantle_absorb': 'magespec.frost_mantle',
  'rimecaller.deep_winter_buff': 'magespec.deep_winter',
  'rimecaller.rimecraft': 'magespec.frozen',
  'cinderborn.ember_lash': 'stormcaller.flame_shock',
  'cinderborn.cinderfall': 'stormcaller.lava_beam',
  'cinderborn.inferno_ring': 'warden.t3.lockdown',
  'cinderborn.phoenix_dive': 'magespec.phoenix_dive',
  'cinderborn.pyre_burst': 'stormcaller.lava_surge',
  'cinderborn.ashrise_pact': 'magespec.ashrise_pact',
  'cinderborn.wandering_sun': 'lightbinder.t3.sunburst',
  'cinderborn.kindled_heart': 'stormcaller.t3.master_of_flame',
  'cinderborn.pyre': 'stormcaller.t3.master_of_flame',
  'cinderborn.ashrise': 'lightbinder.avenging_light',
  'cinderborn.phoenix_form': 'lightbinder.avenging_light',
  'cinderborn.ashes_cooling': 'lightbinder.avenging_light',
  'cinderborn.smoulder': 'stormcaller.flame_shock',
  'cinderborn.inferno_daze': 'warden.t3.lockdown',
  'cinderborn.ashrise_pact_absorb': 'magespec.ashrise_pact',
  'cinderborn.kindled_heart_buff': 'stormcaller.t3.master_of_flame',
  'cinderborn.flashfire': 'stormcaller.lava_burst',
  // +rogue-specs: Shadowdancer / Mirage / Venomwright (abilities and auras).
  'shadowdancer.umbral_finale': 'blademaster.t3.executioner',
  'shadowdancer.duskwalk': 'stormcaller.astral_shift',
  'shadowdancer.veil_of_night': 'npc.mesmer.hypnosis',
  'shadowdancer.umbral_convergence': 'blademaster.t3.ravagers_storm',
  'shadowdancer.silhouette_echo': 'npc.mesmer.hypnotic_gaze',
  'shadowdancer.silhouettes': 'npc.mesmer.hypnotic_gaze',
  'shadowdancer.nightglint': 'blademaster.sudden_death',
  'shadowdancer.nights_edge': 'blademaster.executioners_precision',
  'shadowdancer.convergence_buff': 'blademaster.t3.ravagers_storm',
  'shadowdancer.veil_of_night_buff': 'npc.mesmer.hypnosis',
  'shadowdancer.duskwalk_buff': 'stormcaller.astral_shift',
  'shadowdancer.duskwalk_fight': 'stormcaller.astral_shift',
  'shadowdancer.gloam_stun': 'blademaster.shockwave',
  'mirage.mirror_spin': 'blademaster.bladestorm',
  'mirage.hall_of_mirrors': 'warden.unyielding_bulwark',
  'mirage.haze': 'stormcaller.gathering_storm',
  'mirage.phantoms': 'stormcaller.astral_shift',
  'mirage.sidestep_window': 'common.dodge',
  'mirage.counterpoise': 'warden.opening',
  'mirage.poise': 'warden.riposte',
  'mirage.haze_debuff': 'stormcaller.gathering_storm',
  'mirage.hall_of_mirrors_buff': 'warden.unyielding_bulwark',
  'mirage.lured': 'warden.taunt',
  'venomwright.venom_edge': 'npc.adept.envenom',
  'venomwright.catalyst': 'npc.constrictor.venom_nova',
  'venomwright.creeping_fume': 'coil.coiling_vortex',
  'venomwright.paralytic_opener': 'npc.basilisk.petrifying_glare',
  'venomwright.caustic_roll': 'npc.serpent.acid_spew',
  'venomwright.flask_toss': 'npc.adept.venom_bolt',
  'venomwright.choking_gas': 'npc.basilisk.venom_rain',
  'venomwright.numbing_jab': 'coil.sluggish_venom',
  'venomwright.plaguebloom': 'coil.venom_torrent',
  'venomwright.corrode': 'coil.toxic_atrophy',
  'venomwright.numb': 'npc.constrictor.coagulating_venom',
  'venomwright.blight': 'npc.serpent.acid_burn',
  'venomwright.catalysis': 'npc.constrictor.venom_nova',
  'venomwright.volatile_fumes': 'chieftain.ritual_venom',
  'venomwright.fume_buff': 'coil.coiling_vortex',
  'venomwright.fume_fight': 'coil.coiling_vortex',
  'venomwright.paralysed': 'npc.basilisk.petrified',
  'venomwright.gas_mask': 'npc.basilisk.venom_rain',
  'venomwright.choked': 'npc.basilisk.venom_rain',
  'venomwright.gas_slow': 'coil.sluggish_venom',
  // +acolyte-specs: Lightbinder (gold light), Hemomancer (blood), Heretic (hollow shadow): abilities and auras.
  'lightbinder.triune_ray': 'lightbinder.sunlit_shock',
  'lightbinder.haloburst': 'lightbinder.radiant_wave',
  'lightbinder.lightbound_oath': 'lightbinder.glorious_dawn',
  'lightbinder.blinding_verdict': 'lightbinder.t3.sunburst',
  'lightbinder.exaltation': 'lightbinder.dawnbringer',
  'lightbinder.absolution': 'lightbinder.dawnlight',
  'lightbinder.absolution_bond': 'lightbinder.dawnlight',
  'lightbinder.radiant_ward_absorb': 'lightbinder.guardians_aegis',
  'lightbinder.lightbound_oath_buff': 'lightbinder.glorious_dawn',
  'lightbinder.verdict_stun': 'lightbinder.t3.sunburst',
  'lightbinder.exaltation_buff': 'lightbinder.avenging_light',
  'lightbinder.sunpierce': 'lightbinder.infusion_of_light',
  'hemomancer.blood_bolt': 'npc.reaver.hemorrhage',
  'hemomancer.crimson_bloom': 'chieftain.blood_offering',
  'hemomancer.transfusion': 'npc.reaver.blood_frenzy',
  'hemomancer.scab': 'acospec.scab',
  'hemomancer.bleedfield': 'chieftain.bloodroar_bleed',
  'hemomancer.vein_pact': 'acospec.vein_pact',
  'hemomancer.coagulate': 'acospec.coagulate',
  'hemomancer.martyr': 'chieftain.blood_sacrifice',
  'hemomancer.sanguine_pool': 'chieftain.blood_offering',
  'hemomancer.scab_absorb': 'acospec.scab',
  'hemomancer.vein_pact_buff': 'acospec.vein_pact',
  'hemomancer.coagulated': 'acospec.coagulate',
  'hemomancer.martyr_share': 'chieftain.blood_sacrifice',
  'hemomancer.quickened_blood': 'npc.reaver.blood_frenzy_7',
  'heretic.hexbolt': 'acospec.hexbolt',
  'heretic.rotcurse': 'acospec.rotcurse',
  'heretic.unholy_tithe': 'acospec.unholy_tithe',
  'heretic.wraith_ward': 'acospec.wraith_ward',
  'heretic.blight_field': 'acospec.blight_field',
  'heretic.hollow_covenant': 'acospec.hollow_covenant',
  'heretic.dread_gaze': 'npc.mesmer.hypnotic_gaze',
  'heretic.soulflay': 'npc.adept.ascended',
  'heretic.call_hollow_one': 'npc.mesmer.hypnosis',
  'heretic.hollow_rend': 'ravager.rending_maw',
  'heretic.tithing': 'npc.adept.ascension_rite',
  'heretic.rotcurse_curse': 'acospec.rotcurse',
  'heretic.wraith_ward_absorb': 'acospec.wraith_ward',
  'heretic.hollow_covenant_buff': 'acospec.hollow_covenant',
  'heretic.dread_gaze_disorient': 'npc.mesmer.hypnotic_gaze',
  'heretic.hollow_whisper': 'npc.adept.ascension_rite_7',
  'beastbound.howl': 'rangerspec.howl_shot',
  'beastbound.howl_shot': 'rangerspec.howl_shot',
  'beastbound.pack_sprint': 'rangerspec.trail_stride',
  'beastbound.pack_stride': 'rangerspec.trail_stride',
  'beastbound.spirit_herd': 'rangerspec.spirit_herd',
  'beastbound.bound_leap': 'rangerspec.bound_leap',
  'beastbound.pinned': 'rangerspec.spirit_snare',
  'beastbound.spirit_snare': 'rangerspec.spirit_snare',
  'grovewarden.thornpin': 'rangerspec.thornpin',
  'grovewarden.wildstride': 'rangerspec.wildstride',
  'deadeye.trail_stride': 'rangerspec.trail_stride',
  // +ranger-specs: Deadeye (brass), Grovewarden (bloom), Beastbound (spirit amber): abilities and auras.
  'deadeye.quickdraw': 'rangerspec.quickdraw',
  'deadeye.disarming_shot': 'rangerspec.quickdraw',
  'deadeye.fan_the_hammer': 'rangerspec.hammer_spray',
  'deadeye.ricochet': 'rangerspec.hammer_spray',
  'deadeye.snap_shut': 'rangerspec.snap_shut',
  'deadeye.roll_reload': 'rangerspec.snap_shut',
  'deadeye.reloading': 'rangerspec.snap_shut',
  'deadeye.hot_rounds': 'rangerspec.snap_shut',
  'deadeye.jammed': 'rangerspec.snap_shut',
  'deadeye.high_noon': 'rangerspec.high_noon',
  'deadeye.high_noon_mark': 'rangerspec.high_noon',
  'deadeye.flashbang': 'rangerspec.flashbang',
  'deadeye.rattled': 'rangerspec.flashbang',
  'deadeye.flashbang_stun': 'rangerspec.flashbang',
  'deadeye.explosive_round': 'rangerspec.flashbang',
  'deadeye.steady_hand': 'rangerspec.quickdraw',
  'deadeye.trail_sprint': 'rangerspec.trail_stride',
  'deadeye.gunslinger': 'rangerspec.quickdraw',
  'grovewarden.budding': 'rangerspec.budding',
  'grovewarden.budding_hot': 'rangerspec.budding',
  'grovewarden.quickening': 'rangerspec.budding',
  'grovewarden.grove_stride': 'rangerspec.budding',
  'grovewarden.grove_stride_speed': 'rangerspec.budding',
  'grovewarden.burstbloom': 'rangerspec.burstbloom',
  'grovewarden.petalfall': 'rangerspec.wildstride',
  'grovewarden.lifevine': 'rangerspec.lifevine',
  'grovewarden.lifevine_hot': 'rangerspec.lifevine',
  'grovewarden.overgrowth_surge': 'rangerspec.overgrowth_surge',
  'grovewarden.thicket': 'rangerspec.overgrowth_surge',
  'grovewarden.worldroot': 'rangerspec.worldroot',
  'grovewarden.worldroot_buff': 'rangerspec.worldroot',
  'grovewarden.snarlroot': 'rangerspec.snarlroot',
  'grovewarden.snarled': 'rangerspec.snarlroot',
  'beastbound.mark_prey': 'rangerspec.mark_prey',
  'beastbound.marked_prey': 'rangerspec.mark_prey',
  'beastbound.pounce': 'rangerspec.mark_prey',
  'beastbound.pack_fury': 'rangerspec.pack_fury',
  'beastbound.fury_bite': 'rangerspec.pack_fury',
  'beastbound.spirit_rend': 'rangerspec.pack_fury',
  'beastbound.kindred_spirit': 'rangerspec.pack_fury',
  'beastbound.spirit_merge': 'rangerspec.spirit_merge',
  'beastbound.spirit_merge_buff': 'rangerspec.spirit_merge',
  'beastbound.reforming': 'rangerspec.spirit_merge',
  'beastbound.spirit_bond': 'rangerspec.spirit_merge',
  'beastbound.guard': 'rangerspec.stand_guard',
  'beastbound.hunt': 'rangerspec.mark_prey',
  'beastbound.guarding': 'rangerspec.stand_guard',
  'beastbound.guard_stance': 'rangerspec.stand_guard',
  'beastbound.growl': 'rangerspec.stand_guard',
  'beastbound.interpose': 'rangerspec.bound_leap',
  'beastbound.maul': 'rangerspec.fanged_maul',
  'beastbound.maul_bite': 'rangerspec.fanged_maul',
  'beastbound.maul_bleed': 'rangerspec.fanged_maul',
  'beastbound.spirit_pin': 'rangerspec.spirit_snare',
};

export type IconSize = 64 | 128;

const base = (): string => (import.meta.env?.BASE_URL ?? '/').replace(/\/?$/, '/');

/** URL of the icon for an ability or aura id, or null when there is none. */
export function iconUrl(abilityOrAuraId: string, size: IconSize = 128): string | null {
  const file = ICON_MANIFEST[abilityOrAuraId] ?? ICON_MANIFEST[BASE_ICON[abilityOrAuraId] ?? SPEC_ICON[abilityOrAuraId] ?? ''] ?? ICON_MANIFEST[BASE_VISUAL_ALIAS[abilityOrAuraId] ?? '']; // +classes / +basekits / +specs
  if (!file) return null;
  return `${base()}assets/icons/${file}${size === 64 ? '_64' : ''}.png`;
}

/** URL of the icon for a talent node id, or null when there is none. */
export function talentIconUrl(nodeId: string, size: IconSize = 128): string | null {
  const key = TALENT_ICON[nodeId];
  return key ? iconUrl(key, size) : null;
}
